import languages from '../../../_data/languages.js'

let templates = {}
let more = [
  'sr-latn-cyrl', //first parameter latin, second cyrillic
  'sr-cyrl-latn', //first parameter cyrillic, second latin
  'sr-latn', //one parameter latin
  'sr-cyrl', //one parameter cyrillic
  'sr-cyr',
  'sh-latn-cyrl', //for both Latin and Cyrillic in that order
  'sh-cyrl-latn', //for both Cyrillic and Latin in that order
  'sh-latn', //for Latin
  'sh-cyrl', //for Cyrillic
  'cel-1bd',
  'cel-x-proto',
  'en-emodeng',
  'de-at',
  'de-ch',
  'gem-x-proto',
  'gsw-fr',
  'nds-nl',
  'nl-be',
  'ku-arab',
  'ku-cyrl',
  'pt-br',
  'fra-frc',
  'fra-que',
  'roa-leo',
  'roa-nor',
  'ca-valencia',
  'ast-leo',
  'grc-gre',
  'grc-x-doric',
  'grc-x-proto',
  'grc-x-medieval',
  'cpg',
  'gmy',
  'grc',
  'grk-x-proto',
  'pnt',
  'mga',
  'owl',
  'pgl',
  'sga',
  'wlm',
  'xbm',
  'xcb',
  'xcg',
  'xpi',
  'aae',
  'aln',
  'sq-definite',
  'bs-cyrl',
  'hsb',
  'ltg',
  'orv',
  'prg',
  'rsk',
  'rue',
  'rus',
  'sgs',
  'sla',
  'szl',
  'wen',
  'aoa',
  'chn',
  'cri',
  'dlm',
  'egl',
  'fax',
  'frc',
  'frm',
  'fro',
  'fr-gallo',
  'oc-gascon',
  'gcf',
  'gcr',
  'ist',
  'la-x-medieval',
  'lij-mc',
  'lld',
  'lou',
  'mfe',
  'mol',
  'mwl',
  'mxi',
  'nrf',
  'osc',
  'osp',
  'pcd',
  'pln',
  'rcf',
  'rgn',
  'roa',
  'ruo',
  'rup',
  'ruq',
  'sdc',
  'sdn',
  'src',
  'sro',
  'xvo',
  'bzj',
  'cim',
  'dum',
  'enm',
  'frk',
  'frr',
  'frs',
  'gmh',
  'gml',
  'gmw',
  'goh',
  'gos',
  'gsw',
  'gyn',
  'icr',
  'jam',
  'kri',
  'lng',
  'nb',
  'non',
  'nrn',
  'odt',
  'ofs',
  'osx',
  'pey',
  'sli',
  'srm',
  'srn',
  'stq',
  'swg',
  'vmf',
  'wae',
  'wep',
  'wes',
  'zea',
  'hmd',
  'hoc',
  'kha',
  'mnw',
  'mtq',
  'vi-chunom',
  'vi-hantu',
  'mvi',
  'rys',
  'ryu',
  'yoi',
  'ace',
  'akl',
  'ami',
  'bew',
  'bik',
  'bjn',
  'bya',
  'cal',
  'cbk',
  'cjm',
  'coa',
  'cyo',
  'dev',
  'fil',
  'gad',
  'hil',
  'iba',
  'ibg',
  'ibl',
  'ilp',
  'itv',
  'ivv',
  'jax',
  'kne',
  'krj',
  'kxd',
  'ljp',
  'mad',
  'mak',
  'mdh',
  'mrv',
  'mrw',
  'ms-arab',
  'nia',
  'niu',
  'pau',
  'pwn',
  'rap',
  'rar',
  'sgd',
  'su-fonts',
  'szy',
  'tao',
  'tkl',
  'tsg',
  'tvl',
  'uli',
  'wls',
  'xsb',
  'yap',
  'yka',
  'ckt',
  'itl',
  'brh',
  'oty',
  'tcy',
  'abq',
  'ady',
  'ddo',
  'inh',
  'kbd',
  'lbe',
  'lez',
  'rut',
  'tab',
  'uby',
  'udi',
  'bai',
  'bin',
  'bsq',
  'dag',
  'dyu',
  'efi',
  'fan',
  'fmp',
  'fuc',
  'fuf',
  'gaa',
  'ibb',
  'kbp',
  'kcg',
  'kpo',
  'ktu',
  'lu',
  'lua',
  'lun',
  'mkw',
  'mos',
  'oaa',
  'sjo',
  'ude',
  'anm',
  'bft',
  'blk',
  'brx',
  'dng',
  'kjp',
  'kjz',
  'ksw',
  'lbj',
  'lus',
  'aae',
  'aaq',
  'abe',
  'abq',
  'aca',
  'ace',
  'acf',
  'acm',
  'acw',
  'ady',
  'ae',
  'aeb',
  'aec',
  'aer',
  'afb',
  'aht',
  'aii',
  'aij',
  'ain',
  'aiq',
  'akk',
  'akl',
  'akz',
  'ale',
  'aln',
  'alq',
  'alt',
  'ami',
  'anm',
  'aoa',
  'apj',
  'apm',
  'apw',
  'ayn',
  'arb',
  'arh',
  'ari',
  'arn',
  'arp',
  'arq',
  'ary',
  'arz',
  'asb',
  'ath',
  'ats',
  'awa',
  'axm',
  'azb',
  'azd',
  'azj',
  'bai',
  'bal',
  'ban',
  'bax',
  'bdz',
  'bea',
  'ber',
  'bew',
  'bft',
  'bgn',
  'bho',
  'bik',
  'bin',
  'bjn',
  'bla',
  'blc',
  'blk',
  'bqi',
  'brh',
  'brx',
  'bsk',
  'bsq',
  'bua',
  'bvb',
  'bya',
  'bzj',
  'cal',
  'cay',
  'cbk',
  'ccp',
  'chg',
  'chm',
  'chn',
  'chp',
  'cic',
  'cim',
  'ciw',
  'cjm',
  'cjs',
  'ckb',
  'ckt',
  'cku',
  'cld',
  'clm',
  'cmg',
  'cmn',
  'cms',
  'cnu',
  'coa',
  'coc',
  'coj',
  'com',
  'coo',
  'cop',
  'cpg',
  'crg',
  'crh',
  'cri',
  'crj',
  'crk',
  'crl',
  'crm',
  'cro',
  'csw',
  'csz',
  'ctg',
  'ctm',
  'cyo',
  'dag',
  'dak',
  'ddo',
  'deh',
  'del',
  'den',
  'dev',
  'din',
  'dlm',
  'dng',
  'dum',
  'dyu',
  'efi',
  'egl',
  'egy',
  'elx',
  'eml',
  'ems',
  'cmn',
  'och',
  'yue',
  'mjw',
  'mni',
  'my-name-mlcts',
  'nan',
  'nwc',
  'omp',
  'otb',
  'pwo',
  'sip',
  'xct',
  'xsr',
  '1ca',
  'alt',
  'az-arab',
  'azb',
  'azj',
  'chg',
  'cjs',
  'crh',
  'crh3',
  'kaa',
  'kjh',
  'krc',
  'kum',
  'nog',
  'ota',
  'otk',
  'sah',
  'slr',
  'sty',
  'tt-arab',
  'tt-cyrl',
  'tt-latn',
  'tyv',
  'uniturk',
  'chm',
  'est-sea',
  'fit',
  'fkv',
  'izh',
  'jmy',
  'koi',
  'krl',
  'liv',
  'mdf',
  'mhr',
  'mrj',
  'myv',
  'olo',
  'sia',
  'sjd',
  'sje',
  'sjk',
  'sjt',
  'sju',
  'sma',
  'smi',
  'smj',
  'smn',
  'sms',
  'vep',
  'vot',
  'vro',
  'yrk',
  'din',
  'luo',
  'srr',
  'sus',
  'swh',
  'umb',
  'yao',
]

// more languages
more.forEach((k) => {
  templates['lang-' + k] = 0
})

//https://en.wikipedia.org/wiki/Category:Lang-x_templates
Object.keys(languages).forEach((k) => {
  templates['lang-' + k] = 0
})
export default templates